import React from 'react';

export default function BiDirectionalSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 36 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.21484 10.2016H31.0126L18.1259 1.74609"
        stroke="#9E9E9E"
        strokeWidth="2.53666"
      />
      <path
        d="M35.0371 15.2749L5.23938 15.2749L18.1261 23.7305"
        stroke="#9E9E9E"
        strokeWidth="2.53666"
      />
    </svg>
  );
}
